import type { Company } from '@/entities/company'
import { writeThroughErrorText } from '@/shared/api'
import { InlineLinks } from '@/shared/ui/inline-links'
import { toast } from '@/shared/ui/toast'
import { useEditCompany } from '../api/edit'

interface CompanyLinksBlockProps {
  company: Pick<Company, 'id' | 'links'>
  /** Правка (employee-only); заказчик видит read-only. */
  editable: boolean
}

// Блок ссылок компании с inline-правкой (replace-семантика PATCH links).
export function CompanyLinksBlock({ company, editable }: CompanyLinksBlockProps) {
  const edit = useEditCompany(company.id)
  return (
    <InlineLinks
      links={company.links}
      editable={editable}
      saving={edit.isPending}
      onSave={(links) =>
        edit.mutate(
          { links },
          {
            onError: (e) => toast.error(writeThroughErrorText(e) ?? 'Не удалось сохранить ссылки'),
          },
        )
      }
    />
  )
}
